import { IResourceList } from 'src/components/challenge/ChallengeInterfaces';
import { ResourceTypeDetailEnum } from 'src/shared/enums';
import { IChallengeCheckoutLottery, IUser } from 'src/shared/models';

const {
  CHECKOUT_LOTTERY_BUTTON_NAME,
  CHECKOUT_LOTTERY_IMAGE,
  CHECKOUT_LOTTERY_TERMS_DOCUMENT,
  CHECKOUT_LOTTERY_TERMS_LABEL,
  CHECKOUT_LOTTERY_TEXT,
  CHECKOUT_LOTTERY_ORDER_DESCRIPTION,
  CHECKOUT_LOTTERY_ORDER_TITLE,
  CHECKOUT_LOTTERY_STICKY_TEXT,
  CHECKOUT_LOTTERY_SHOW_ORDER,
  CHECKOUT_LOTTERY_SUCCESS_WYSWYG,
} = ResourceTypeDetailEnum;

export const buildChallengeCheckoutLottery = (
  resource: IResourceList,
  user: IUser
): IChallengeCheckoutLottery => {
  const { resourceDetailList, name: title, idResource, score } = resource;
  let item: IChallengeCheckoutLottery;

  resourceDetailList
    .filter(({ status }) => status)
    .forEach(({ idResourceTypeD: { idResourceTypeD }, value }) => {
      switch (idResourceTypeD) {
        case CHECKOUT_LOTTERY_BUTTON_NAME:
          item = { ...item, buttonName: value };
          break;
        case CHECKOUT_LOTTERY_IMAGE:
          item = { ...item, image: value };
          break;
        case CHECKOUT_LOTTERY_TERMS_LABEL:
          item = { ...item, termsLabel: value };
          break;
        case CHECKOUT_LOTTERY_TERMS_DOCUMENT:
          item = { ...item, termsUrl: value };
          break;
        case CHECKOUT_LOTTERY_TEXT:
          item = { ...item, text: value };
          break;
        case CHECKOUT_LOTTERY_STICKY_TEXT:
          item = { ...item, textTopButton: value };
          break;
        case CHECKOUT_LOTTERY_ORDER_TITLE:
          item = { ...item, orderTitle: value };
          break;
        case CHECKOUT_LOTTERY_ORDER_DESCRIPTION:
          item = { ...item, orderDescription: value };
          break;
        case CHECKOUT_LOTTERY_SHOW_ORDER:
          item = { ...item, hasOrderStep: value === 'true' };
          break;
        case CHECKOUT_LOTTERY_SUCCESS_WYSWYG:
          const content = value
            ? value
                .replace('{{userName}}', user.temporalData.name)
                .replace('{{userPoints}}', user.points.toString())
            : '';
          item = { ...item, successStepContent: content };
          break;
      }
    });

  return {
    ...item,
    title,
    idResource,
    points: score?.points || 0,
  };
};
